/**
 * 快捷短语
 * TODO
 * 2、动态push逻辑
 */
import $ from '@ali/tarzan-zepto';
import events from 'events';
import tpl from './tpl.html';
import util from '../../../lib/util.js';
import { quickAction } from '../../../utils';
import './style.scss';

const STORAGE_SHORTCUT = 'shortcut-clicked';
const LOG_C = 'shortcut';
const clickType = util.click();
const isPC = util.isPC();

export default class Shortcuts extends events {
  constructor(app) {
    super();
    this.app = app;
    this.$wrap = app.view.footer.$shortcuts;
    /**
     * 保存当前展示的快捷短语
     */
    this.shortcuts = [];

    this.init();
    this.bindEvents();
  }

  init() {
    const appConfig = this.app.appConfig;
    const shortcuts = appConfig.get('appConfig').shortcuts || [];
    // 渲染快捷短语
    // if (shortcuts.length === 0) return;
    this.render({
      shortcuts,
    });
  }

  // 动态push数据
  push(data) {
    let list = data.shortcuts;
    // 新增一项或几项，比如新增一个转人工入口
    if (data.isAdd) {
      list = data.shortcuts.concat(this.shortcuts);
      let isDispatchExist = false;
      list.forEach((t, i) => {
        if (t.code === 'dispatch') {
          if (isDispatchExist) {
            list.splice(i, 1);
          } else {
            isDispatchExist = true;
          }
        }
      });
    }
    data.shortcuts = list;
    setTimeout(() => {
      this.render(data);
    });
  }

  render(data) {
    // const clicked = this.app.util.storage.getItem(STORAGE_SHORTCUT);
    // const clickedList = (clicked ? JSON.parse(clicked) : []) || [];
    data.shortcuts.forEach((t) => {
      // if (t && clickedList.indexOf(t.code) < 0) {
      //   t.isNew = true;
      // } else {
      //   t.isNew = false;
      // }
      t.isNew = false;
      // 快捷短语来源，1表示配置，2表示来自机器人算法
      t.source = t.source || 1;
    });
    const $node = $(tpl.render(data));
    this.$wrap.empty().append($node);
    this.shortcuts = data.shortcuts.concat([]);
    this.app.view.footer.showShortcuts();
    this.app.view.resize();
    if (isPC) {
      $('#csc-shortcuts').addClass('-pc');
    }
    this.$closeButton = $node.find('#alime-shortcuts-close-button');
  }

  bindEvents() {
    const app = this.app;
    // 进入人工客户,需要隐藏快捷短语
    app.on(app.events.CHANNEL_OCS_ONLINE, () => {
      app.view.footer.hideShortcuts();
    });

    // 进入机器人流程,需要显示快捷短语
    app.on(app.events.CHANNEL_ROBOT_ONLINE, () => {
      app.view.footer.showShortcuts();
    });
    this.$wrap.delegate('.J_Item', clickType, ev => this.onClickShortcut(ev));
    this.$wrap.delegate('#alime-shortcuts-close-button', clickType, () => {
      app.view.footer.hideShortcuts();
    });

    this.$wrap.delegate('#shortcut-end-conversation', clickType, ev => this.endConversation(ev));
  }

  endConversation() {
    this.app.util.goldlog('LIVE_CHAT_END_SESSION');
    this.app.view.footer.showEndConversationHolder();
  }

  switchToRobot() {
    const hideModifier = '-hidden';
    this.$wrap.find('#agent-shortcuts-list').addClass(hideModifier);
    if (this.shortcuts.length) {
      this.$wrap.find('#bot-shortcuts-list').removeClass(hideModifier);
    } else {
      this.$wrap.hide();
      this.app.view.body.resize();
    }
    this.$closeButton.show();
  }

  switchToAgent() {
    const hideModifier = '-hidden';
    this.$wrap.show();
    this.$wrap.find('#agent-shortcuts-list').removeClass(hideModifier);
    this.$wrap.find('#bot-shortcuts-list').addClass(hideModifier);
    this.$closeButton.hide();
  }

  hideAgent() {
    if (this.agentHidden) return;
    this.shortcuts = this.shortcuts.filter(item => (
      item.code !== 'liveAgent'
    ));
    if (this.shortcuts.length) {
      this.render({
        shortcuts: this.shortcuts,
      });
    } else {
      this.app.view.footer.hideShortcuts();
    }
    this.agentHidden = true;
  }

  onClickShortcut(ev) {
    if (quickAction('shortcut')) {
      return;
    }
    const app = this.app;
    const footer = app.view.footer;
    const $target = $(ev.currentTarget);
    const type = $target.attr('data-type');
    const q = $target.attr('data-means');
    // const text = $target.attr('data-text');
    const code = $target.attr('data-code');
    if (type === 'text') {
      // send text message
      if (code === 'liveAgent') {
        this.app.emit('liveAgent',
        { entry: this.app.liveAgent.entry, type: 'click', chatUuid: this.app.chatUuid, intent: '' });
      }
      footer.submit({
        q,
        header: {
          originContent: q,
        },
      });
    } else if (type === 'link') {
      const link = document.createElement('a');
      link.href = q;
      link.target = '_blank';
      link.click();
      $(link).remove();
    } else if (type === 'dispatch') {
      // go to live agent
      this.__dispatch(q, $target);
    } else if (type === 'url') {
      app.util.openWindow(q);
    } else if (type === 'card') {
      const d = JSON.parse(q);
      let body = null;
      // 已经有卡片数据
      if (d.header && d.header.contentType !== 'req') {
        body = {
          data: d,
        };
      } else {
        // 异步取数据
        body = {
          cardId: d.header.styleId,
          parameters: d.header.parameters,
        };
      }
      app.appendMessage({
        type: 'card',
        body,
      });
    }
    // set read status
    if ($target.hasClass('light')) {
      const clicked = util.storage.getItem(STORAGE_SHORTCUT);
      const clickedList = (clicked ? JSON.parse(clicked) : []) || [];
      $target.removeClass('light');
      clickedList.push(code);
      util.storage.setItem(STORAGE_SHORTCUT, JSON.stringify(clickedList));
    }
    this.__log($target);
  }

  __log($el) {
    const app = this.app;
    const log = app.log;
    const id = $el.attr('data-code');
    const text = $el.text().trim();
    const chatUuid = $el.attr('data-chatUuid');
    const source = parseInt($el.attr('data-source'), 10);
    const isNew = $el.hasClass('light') ? 'Y' : 'N';
    const path = $el.attr('data-path');
    const position = this.$wrap.index($el);

    log.send({
      c: LOG_C,
      d: 'shortcuts',
      c3: id,
      c4: text,
      c5: isNew,
      c6: position,
      c7: path,
      c8: source,
      chatUuid,
    });
  }

  __refreshView() {
    const $shortcuts = this.$wrap.find('#csc-shortcuts');
    $shortcuts.scrollLeft(0);
  }

/**
 * go to liveAgent
 */
  __dispatch() {
    this.app.emit('liveAgent');
  }
}



// WEBPACK FOOTER //
// ./src/app/module/shortcuts/shortcuts.js